import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ProductsForecastInfo} from '../types'

export const ProductsSalesForecastInfoQueryKey = 'productsSalesForecastInfo'

const productsSalesForecastInfoQueryOptions = (plantCode: string, materialId: number) => ({
  queryKey: [ProductsSalesForecastInfoQueryKey, plantCode, materialId] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<ProductsForecastInfo>(
      `/plants/${plantCode}/material-demand/${materialId}/demand/prediction/status`,
      {signal}
    )
    return response.data
  }
})

type Params<TReturn = ProductsForecastInfo> = {
  plantCode: string
  materialId: number
  options?: Omit<UseQueryOptions<ProductsForecastInfo, AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useProductsSalesForecastInfo = <TReturn = ProductsForecastInfo>({
  plantCode,
  materialId,
  options
}: Params<TReturn>) =>
  useQuery<ProductsForecastInfo, AxiosError, TReturn>({
    ...productsSalesForecastInfoQueryOptions(plantCode, materialId),
    ...options
  })
